import 'bootstrap/js/dist/modal';
import Swiper from 'swiper';
import {Navigation, Scrollbar} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

(function($) {
    if ($('.video-modal__link--button').length > 0) {
        $('.video-modal__link--button').on('click', function(e) {
            e.preventDefault();
        });
    }

    $('.modal').on('hide.bs.modal', function() {
        const backupVideoClose = $(this).html();
        $(this).html(backupVideoClose);
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    });
})(jQuery);


window.addEventListener('DOMContentLoaded', (event) => {
    const swiper = new Swiper('.swiper', {
        modules: [Navigation, Scrollbar],
        navigation: {
            nextEl: '.navigation-right',
            prevEl: '.navigation-left',
        },
        spaceBetween: 20,
        slidesPerView: 1.2,
        breakpoints: {
            480: {
                slidesPerView: 1,
                slidesPerView: 1.2,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 4,
            },
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        on: {
            init: function(thisSwiper) {
                const element = document.querySelectorAll('[data-headerid="' + thisSwiper.el.dataset.id + '"]')[0];
                if (element) {
                    if (window.innerWidth >= 1025) {
                        if (element.classList.contains('starts-begining')) {
                            document
                                .querySelectorAll('[data-id="' + thisSwiper.el.dataset.id + '"]')[0]
                                .style.paddingLeft = '0px';
                        } else {
                            const positionLeft = element.getBoundingClientRect().x;
                            document
                                .querySelectorAll('[data-id="' + thisSwiper.el.dataset.id + '"]')[0]
                                .style.paddingLeft = parseInt(positionLeft) + 'px';
                        }
                    }

                    [...document.querySelectorAll('.swiper[data-id="' + thisSwiper.el.dataset.id + '"] .swiper-slide')]
                        .forEach((element) => {
                            element.style.minWidth = element.style.width;
                        });
                }
            },
            afterInit: function(thisSwiper) {
                thisSwiper.params.breakpoints[480].slidesPerView = thisSwiper.el.dataset.mobile;
                thisSwiper.params.breakpoints[768].slidesPerView = thisSwiper.el.dataset.tablet;
                thisSwiper.params.breakpoints[1024].slidesPerView = thisSwiper.el.dataset.desktop;
                thisSwiper.currentBreakpoint = false;
                thisSwiper.update();
            },
        },
    });


    const globalSwipers = document.querySelectorAll('.swiper');
    globalSwipers.forEach((currentSwiper) => {
        const element = document.querySelectorAll('[data-headerid="' + currentSwiper.dataset.id + '"]')[0];
        if (element) {
            if (window.innerWidth >= 1025) {
                if (element.classList.contains('starts-begining')) {
                    document
                        .querySelectorAll('[data-id="' + currentSwiper.dataset.id + '"]')[0]
                        .style.paddingLeft = '0px';
                } else {
                    const positionLeft = element.getBoundingClientRect().x;
                    document
                        .querySelectorAll('[data-id="' + currentSwiper.dataset.id + '"]')[0]
                        .style.paddingLeft = parseInt(positionLeft) + 'px';
                }
            }
    
            [...document.querySelectorAll('.swiper[data-id="' + currentSwiper.dataset.id + '"] .swiper-slide')]
                .forEach((element) => {
                    element.style.minWidth = element.style.width;
                });
        }
    });
});

window.onresize = (e) => {
    const elements = document.querySelectorAll('.slider-taxonomy__header');
    if (elements) {
        if (window.innerWidth >= 1025) {
            elements.forEach((element) => {
                if (element.classList.contains('starts-begining')) {
                    document
                        .querySelectorAll('[data-id="' + element.dataset.headerid + '"]')[0]
                        .style.paddingLeft = '0px';
                } else {
                    const positionLeft = element.getBoundingClientRect().x;
                    document
                        .querySelectorAll('[data-id="' + element.dataset.headerid + '"]')[0]
                        .style.paddingLeft = parseInt(positionLeft) + 'px';
                }
            });
        }
        [...document.querySelectorAll('.swiper-slide')].forEach((element) => {
            element.style.minWidth = element.style.width;
        });
    }
};
